<template>
  <div class="miniProgress">
      <div class="progressWrap">
        <div
          class="progress"
          :style="{width: percent ? `${percent}%` : null}"
        />
      </div>
    </div>
</template>

<style lang="stylus" scoped>
.miniProgress {
  position: relative;
  width: 100%;
  padding: 0 0 42.5px 0;
  .progressWrap {
    width: 100%;
    height: 28px;
    background:rgba(245,245,245,1);
    border-radius:14px;
    padding: 4px;
  }
  .progress {
    width: 0;
    height: 20px;
    background:linear-gradient(90deg,rgba(2,190,164,1) 0%,rgba(125,242,139,1) 100%);
    box-shadow:0 2px 6px 0 rgba(0,0,0,0.06);
    border-radius:10px;
    transition: all 0.4s cubic-bezier(0.08, 0.82, 0.17, 1) 0s;
  }
}
</style>
<script>

export default {

  data() {
    return {

    }
  },
  props: {
    percent: Number
  },
  methods: {

  },
  mounted() {
  }
}
</script>
